import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "form__fields" }
const _hoisted_4 = { class: "form__desc" }
const _hoisted_5 = ["value", "onClick"]
const _hoisted_6 = {
  key: 0,
  class: "form__numberDesc"
}
const _hoisted_7 = ["onUpdate:modelValue", "disabled"]

import { onMounted, ref, computed } from "vue";
import { presence, vacation, overhours } from "@/config/dayInfoFields";
import { Group, Overhours, Presence, userDay } from "@/types/dailyInfo";
import { useUserDaysStore } from "@/store/userDays";
import { useLangStore } from "@/store/lang";


export default /*#__PURE__*/_defineComponent({
  __name: 'SetdayDialog',
  props: {
  date: {
    type: Object,
    default: () => {
      return { day: 0, month: 0, year: 0 };
    },
  },
  edit: {
    type: Boolean,
    default: false,
  },
},
  emits: ["closeSetDayDialog"],
  setup(__props, { emit: emits }) {

const props = __props;

const userDaysStore = useUserDaysStore();
const langStore = useLangStore();

const messages = computed(() => {
  return langStore.messages.dailyInfo;
});





const checked = ref("");
const previousCheck = ref("");

const fields = ref([
  {
    description: "Obecność",
    group: Group.Presence as Group,
    numberfield: true,
    hours: 0,
    items: presence,
  },
  {
    description: "Nadgodziny",
    group: Group.Overhours as Group,
    numberfield: true,
    hours: 0,
    items: overhours,
  },
  {
    description: "Urlopy",
    group: Group.Vacation as Group,
    numberfield: false,
    hours: 0,
    items: vacation,
  },
]);

const changeDayInfo = () => {
  const checkedDay = userDaysStore.dailyInfo.filter((el) => {
    return el.day === props.date.day.value;
  });
  checked.value = checkedDay[0].value;
  const group = fields.value.find((el) => el.group === checkedDay[0].group);
  if (group)
    fields.value[fields.value.indexOf(group)].hours = checkedDay[0].hours;
};

const setDailyInfo = () => {
  const fieldsFiltered = fields.value.filter((el) => {
    for (const item of el.items) {
      if (item.value === checked.value) {
        return true;
      }
    }
  });

  const dailyData = {
    year: props.date.year.value,
    month: props.date.month.value,
    day: props.date.day.value,
    group: fieldsFiltered[0].group,
    value: checked.value,
    hours: fieldsFiltered[0].hours,
  } as userDay;
  userDaysStore.addInfo(dailyData);

  emits("closeSetDayDialog");
};

const uncheck = (val: string) => {
  previousCheck.value = checked.value;
  if (val === previousCheck.value) {
    checked.value = "";
  }
};

onMounted(() => {
  if (props.edit) changeDayInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_dialog = _resolveComponent("base-dialog")!

  return (_openBlock(), _createBlock(_component_base_dialog, { setDay: "" }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("form", {
          class: "form",
          onSubmit: _withModifiers(setDailyInfo, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value, (field) => {
              return (_openBlock(), _createElementBlock("fieldset", {
                key: field.description,
                class: "form__info"
              }, [
                _createElementVNode("legend", _hoisted_4, _toDisplayString(field.description), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.items, (item) => {
                  return (_openBlock(), _createElementBlock("label", {
                    class: "form__field",
                    key: item.description
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "presence",
                      value: item.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
                      class: "form__radio",
                      onClick: ($event: any) => (uncheck(item.value))
                    }, null, 8, _hoisted_5), [
                      [_vModelRadio, checked.value]
                    ]),
                    _createTextVNode(" " + _toDisplayString(item.description), 1)
                  ]))
                }), 128)),
                (field.numberfield)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_6, [
                      _createTextVNode(_toDisplayString(_unref(messages).hoursCountText) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": ($event: any) => ((field.hours) = $event),
                        min: "1",
                        max: "24",
                        class: "form__textfield",
                        disabled: 
                  (field.group === _unref(Group).Overhours &&
                    !(
                      checked.value === _unref(Overhours).fifty ||
                      checked.value === _unref(Overhours).hundert
                    )) ||
                  (field.group === _unref(Group).Presence &&
                    !(
                      checked.value === _unref(Presence).notfullday ||
                      checked.value === _unref(Presence).nightnotfullday
                    ))
                
                      }, null, 8, _hoisted_7), [
                        [_vModelText, field.hours]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createVNode(_component_base_button, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(messages).saveText), 1)
            ]),
            _: 1
          })
        ], 40, _hoisted_2)
      ])
    ]),
    _: 1
  }))
}
}

})